import * as React from "react";
import Box from "@mui/material/Box";
import "@fontsource/lato";
import "@fontsource/montserrat";
import { Theme} from "../styles/styles";
import { ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import { StatusBox } from "./StatusBox";
import { IconMenu } from "./IconMenu";
import { Button } from "@mui/material";
import './LeadListItem.css';

export const LeadListItem = ({
  isReviewer = false,
  misot: epid = "Brak",
  date,
  location,
  handleTime,
  status,
  note,
  onClickEdit,
  onClickHistory,
  onClickPreview,
  onClickStatusChange,
  onClieckLeadView,
  onClickNotesView,
 onDeleteClientData,
  handleAcceptLead,
  handleRejectLead,
  showvertIcon = true,

  itemList,
}) => {

    const showerIconBox = () => {
        return (
            <Box className="shower-icon-box" >
                <Avatar className="avatar">
                    <MapOutlinedIcon className="map-outlined-icon"/>
                </Avatar>
            </Box>
        )
    }

    const dataBox = () => {
        return (
            <Box className="data-box">
                <Typography variant="bodyMediumRegural">Data</Typography>
                <Typography variant="bodyMediumBlack">{date}</Typography>
            </Box>
        )
    }

    const addressBox = () => {
        return (
            <Box className="address-box">
                <Typography variant="bodyMediumRegural" noWrap className="body-medium-regural">
                    Adres instalacji
                </Typography>
                <Typography variant="bodyMediumBlack" className="body-medium-black">
                    {location}
                </Typography>
            </Box>
        )
    }

    const czasRealizacjiBox = () => {
        return (
            <Box className="czas-realizacji-box">
                <Typography variant="bodyMediumRegural">Czas realizacji</Typography>
                <Typography variant="bodyMediumBlack">{handleTime}</Typography>
            </Box>
        )
    }

    const statusBox = () => {
        return (
            <Box className="status-box">
                <Typography variant="bodyMediumRegural">Status</Typography>
                <StatusBox statusMessage={status} />
            </Box>
        )
    }

    const epidBox = () => {
        return (
            <Box className="epid-box">
                <Typography variant="bodyMediumRegural">EPID</Typography>
                <Typography variant="bodyMediumBlack">{epid || '?'}</Typography>
            </Box>
        )
    }

    const noteBox = () => {
        return (
            <Box className="note-box">
                <Typography variant="bodyMediumRegural">Notatka</Typography>
                <Typography variant="bodyMediumBlack">{note}</Typography>
            </Box>
        )
    }

    const acceptRejectBtnBox = () => {
        return (
            <Box className="btn-box">
                <Button
                    onClick={handleAcceptLead}
                    sx={Theme.outlinedAcceptButton}
                >
                    Przyjmuję
                </Button>
                <Button
                    onClick={handleRejectLead}
                    disabled={false}
                    sx={Theme.outlinedCancelButton}
                >
                    Odrzucam
                </Button>
            </Box>
        )
    }

    const leadViewBtn = () => {
        return (
            <Box className="lead-view-box">
                <IconMenu
                    onClickHistory={onClickHistory}
                    optionSelected={onClickEdit}
                    onClickStatusChange={onClickStatusChange}
                    onClieckLeadView={onClieckLeadView}
                    onClickNotesView={onClickNotesView}
                    onDeleteClientData={onDeleteClientData}
                    list={["Podgląd leada", "Notatki", "Usuń klienta"]}
                    onClickPreview={() => {
                        onClickPreview();
                    }}
                />
            </Box>
        )
    }

    const listViewBtn = () => {
        return (
            <Box className="list-view-box">
                <IconMenu
                    onClickHistory={onClickHistory}
                    optionSelected={onClickEdit}
                    onClickStatusChange={onClickStatusChange}
                    onClieckLeadView={onClieckLeadView}
                    onClickNotesView={onClickNotesView}
                    onDeleteClientData={onDeleteClientData}
                    list={itemList}
                    onClickPreview={() => {
                        onClickPreview();
                    }}
                />
            </Box>
        )
    }

    const btnBox = () => {
        var oczekuje = status.match(/Oczekuje na operator/);
        var result;

        if (oczekuje && !isReviewer) {
            result = acceptRejectBtnBox()
        } else if (oczekuje && isReviewer) {
            result = leadViewBtn();
        } else {
            result = listViewBtn();
        }

        return result;
    }

    const leadActionButtonsBox = () => {
        return (
            <Box>
                {btnBox()}
            </Box>
        )
    }

    return (
        <Box className="lead-list-item-row">
            <ThemeProvider theme={Theme}>
                {showvertIcon && (
                    showerIconBox()
                )}

                {isReviewer && (
                    epidBox()
                )}

                {dataBox()}
                {addressBox()}

                <Box className="flex-box">
                    {czasRealizacjiBox()}
                    {statusBox()}

                    {noteBox()}
                    {leadActionButtonsBox()}

                </Box>
            </ThemeProvider>
        </Box>
    );
};
